import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Select from 'react-select';
import axios from 'axios';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
const ManageCatCorpMenu = () => {
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [loading, setLoading] = useState(true);

    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [selectedSchedule, setSelectedSchedule] = useState(null);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [subCategories, setSubCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);

    const [items, setItems] = useState([]);
    const [itemValues, setItemValues] = useState({}); // store quantity & price

    // Fetch schedules
    const fetchItemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
            const list = response.data?.data || [];
            const formatted = list.map(item => ({
                value: String(item.sno),
                label: item.itemschedule_name
            }));
            setMealsPeriod(formatted);
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]);
        }
    };

    // Fetch menu structure by schedule (categories/subcategories/items)
    const fetchMenuBySchedule = async (scheduleID) => {
        if (!scheduleID) return;
        try {
            setLoading(true);
            const response = await axios.get(`${BaseUrl}/manage_order/get_cat_corp_menu/${scheduleID}`);
            const data = response.data?.data || [];

            // Categories
            const uniqueCategories = [...new Map(data.map(item => [item.category_id, item.category]))].map(
                ([id, name]) => ({ value: id, label: name })
            );
            setCategories(uniqueCategories);

            // Subcategories
            const allSubCategories = data.map(sc => ({
                value: sc.sub_category_id,
                label: sc.sub_category,
                category_id: sc.category_id,
                items: sc.items
            }));
            setSubCategories(allSubCategories);

            // Reset selections
            setSelectedCategory(null);
            setSelectedSubCategory(null);
            setItems([]);
            setItemValues({});
        } catch (error) {
            console.error('Failed to fetch menu:', error);
            setCategories([]);
            setSubCategories([]);
            setItems([]);
            setItemValues({});
        } finally {
            setLoading(false);
        }
    };

    // Fetch existing menu data (quantity & price)
    const fetchExistingMenu = async (scheduleID) => {
        if (!scheduleID) return;
        try {
            const response = await axios.get(`${BaseUrl}/cat-corp-menu/${scheduleID}/${branch_id}`);
            const data = response.data?.data || [];

            // Populate itemValues from existing menu
            const values = {};
            data.forEach(subCat => {
                subCat.items.forEach(item => {
                    values[item.id] = {
                        quantity: item.quantity || "",
                        price: item.price || ""
                    };
                });
            });
            setItemValues(values);
        } catch (error) {
            console.error("Failed to fetch existing menu:", error);
            setItemValues({});
        }
    };

    // Handlers
    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        setSelectedSubCategory(null);
        setItems([]);
    };

    const handleSubCategoryChange = (subCategory) => {
        setSelectedSubCategory(subCategory);
        if (!subCategory) {
            setItems([]);
            return;
        }

        // Merge existing quantity & price
        const mergedItems = subCategory.items.map(item => ({
            ...item,
            quantity: itemValues[item.id]?.quantity || item.quantity || "",
            price: itemValues[item.id]?.price || item.price || ""
        }));

        setItems(mergedItems);
    };

    const handleInputChange = (id, field, value) => {
        setItemValues(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: value
            }
        }));
    };

    // const handleSubmit = async () => {
    //     if (!selectedSchedule) {
    //         alert("Please select a schedule");
    //         return;
    //     }

    //     const payloadItems = [];
    //     subCategories
    //         .filter(sc => sc.category_id === selectedCategory?.value)
    //         .forEach(sc => {
    //             sc.items.forEach(item => {
    //                 payloadItems.push({
    //                     item_category_id: sc.category_id,
    //                     item_sub_category_id: sc.value,
    //                     item_id: item.id,
    //                     unit_id: item.measurement_quantity,
    //                     quantity: itemValues[item.id]?.quantity || 0,
    //                     price: itemValues[item.id]?.price || 0
    //                 });
    //             });
    //         });

    //     const payload = {
    //         schedule_id: selectedSchedule.value,
    //         branch_id: branch_id,
    //         items: payloadItems
    //     };

    //     try {
    //         const response = await axios.post(`${BaseUrl}/cat-corp-menu`, payload);
    //         if (response.data.status) {
    //             alert(response.data.message);
    //         } else {
    //             alert("Error: " + response.data.message);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         alert("Something went wrong!");
    //     }
    // };

    // Effects
   
   const handleSubmit = async () => {
    if (!selectedSchedule) {
        toast.error("Please select a schedule");
        return;
    }

    const payloadItems = [];
    subCategories
        .filter(sc => sc.category_id === selectedCategory?.value)
        .forEach(sc => {
            sc.items.forEach(item => {
                payloadItems.push({
                    item_category_id: sc.category_id,
                    item_sub_category_id: sc.value,
                    item_id: item.id,
                    unit_id: item.measurement_quantity,
                    quantity: itemValues[item.id]?.quantity || 0,
                    price: itemValues[item.id]?.price || 0
                });
            });
        });

    const payload = {
        schedule_id: selectedSchedule.value,
        branch_id: branch_id,
        items: payloadItems
    };

    try {
        const response = await axios.post(`${BaseUrl}/cat-corp-menu`, payload);
        if (response.data.status) {
            toast.success(response.data.message); // success toast
        } else {
            toast.error("Error: " + response.data.message); // error toast
        }
    } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
    }
};

   
    useEffect(() => {
        fetchItemSchedule();
    }, []);

    useEffect(() => {
        if (selectedSchedule) {
            fetchMenuBySchedule(selectedSchedule.value).then(() => {
                fetchExistingMenu(selectedSchedule.value);
            });
        }
    }, [selectedSchedule]);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Menu</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Catering & Corp Menu Management</li>
                    </ol>
                </div>
            </div>

            {/* Dropdowns */}
            <div className="d-flex gap-3 mb-3">
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Schedule<span className="required">*</span></label>
                    <Select
                        value={selectedSchedule}
                        onChange={(value) => setSelectedSchedule(value)}
                        options={mealsPeriod}
                        placeholder="Select Schedule"
                        styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
                    />
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Item Category<span className="required">*</span></label>
                    <Select
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        options={categories}
                        placeholder="Select Item Category"
                        isDisabled={!selectedSchedule || loading}
                        styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
                    />
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Item Subcategory<span className="required">*</span></label>
                    <Select
                        value={selectedSubCategory}
                        onChange={handleSubCategoryChange}
                        options={subCategories.filter(sc => sc.category_id === selectedCategory?.value)}
                        placeholder="Select Item Subcategory"
                        isDisabled={!selectedCategory || loading}
                        styles={{ container: (base) => ({ ...base, minWidth: 180 }) }}
                    />
                </div>
            </div>
{/*  
            <div className="mt-3 border border-primary-200 rounded py-2 px-2">
                {loading ? (
                    <Skeleton count={5} height={40} />
                ) : items.length > 0 ? (
                    <div className="row"> 
                        <div className="col-md-6">
                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='text-start'>Food Items</th>
                                <th className='text-center'>Per Person Quantity</th>
                                <th className='text-center'>Per Person Price</th>
                                </tr>
                            </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {items.slice(0, Math.ceil(items.length / 2)).map(item => (
                                        <tr key={item.id}>
                                            <td className='text-black'>{item.name}</td>
                                            <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', height: '100%' }}>
                                                <input
                                                type="number"
                                                className="form-control form-control-sm no-spinner"
                                                value={itemValues[item.id]?.quantity || ""}
                                                style={{
                                                    width: "85px",  
                                                    height: "35px",
                                                    padding: "0 5px",
                                                    textAlign: "right",
                                                    boxSizing: "border-box",
                                                      color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                }}
                                                onChange={(e) => handleInputChange(item.id, "quantity", e.target.value)}
                                                />
                                                <span className='text-black' style={{ display: 'flex', alignItems: 'center' }}>{item.unit_slug}</span>
                                            </div>
                                            </td>
                                             <td className='text-end'>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={itemValues[item.id]?.price || ""}
                                                    style={{
                                                        width: "150px",
                                                        textAlign: "right",
                                                        height: "35px",
                                                        color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                    }}
                                                    onChange={(e) => handleInputChange(item.id, "price", e.target.value)}
                                                />
                                                </td>
                                         
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
 
                        <div className="col-md-6">
                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='text-start'>Food Items</th>
                                    <th className='text-center'>Per Person Quantity</th>
                                    <th className='text-center'>Per Person Price</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {items.slice(Math.ceil(items.length / 2)).map(item => (
                                        <tr key={item.id}>
                                            <td className='text-black'>{item.name}</td>
                                            <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', height: '100%' }}>
                                                <input
                                                type="number"
                                                className="form-control form-control-sm no-spinner"
                                                value={itemValues[item.id]?.quantity || ""}
                                                style={{
                                                    width: "85px",
                                                    height: "35px",
                                                    padding: "0 5px",
                                                    textAlign: "right",
                                                    boxSizing: "border-box",
                                                    color: "black",
                                                    fontSize: "16px",  // increased font size
                                                    fontWeight: "bold" // make text bold
                                                }}
                                                onChange={(e) => handleInputChange(item.id, "quantity", e.target.value)}
                                                />
                                                <span className='text-black' style={{ display: 'flex', alignItems: 'center' }}>{item.unit_slug}</span>
                                            </div>
                                            </td>
                                            <td className='text-end'>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={itemValues[item.id]?.price || ""}
                                                    style={{
                                                        width: "150px",
                                                        textAlign: "right",
                                                        height: "35px",
                                                        color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                    }}
                                                    onChange={(e) => handleInputChange(item.id, "price", e.target.value)}
                                                />
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="text-end mt-3">
                            <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                ) : (
                    <p>No items available.</p>
                )}
            </div> */}

            <div className="mt-3 border border-primary-200 rounded py-2 px-2">
    {loading ? (
        <Skeleton count={5} height={40} />
    ) : selectedSchedule && selectedCategory && selectedSubCategory ? (
        items.length > 0 ? (
            <div className="row">
                  <div className="col-md-6">
                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='text-start'>Food Items</th>
                                <th className='text-center'>Per Person Quantity</th>
                                <th className='text-center'>Per Person Price</th>
                                </tr>
                            </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {items.slice(0, Math.ceil(items.length / 2)).map(item => (
                                        <tr key={item.id}>
                                            <td className='text-black'>{item.name}</td>
                                            <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', height: '100%' }}>
                                                <input
                                                type="number"
                                                className="form-control form-control-sm no-spinner"
                                                value={itemValues[item.id]?.quantity || ""}
                                                style={{
                                                    width: "85px",  
                                                    height: "35px",
                                                    padding: "0 5px",
                                                    textAlign: "right",
                                                    boxSizing: "border-box",
                                                      color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                }}
                                                onChange={(e) => handleInputChange(item.id, "quantity", e.target.value)}
                                                />
                                                <span className='text-black' style={{ display: 'flex', alignItems: 'center' }}>{item.unit_slug}</span>
                                            </div>
                                            </td>
                                             <td className='text-end'>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={itemValues[item.id]?.price || ""}
                                                    style={{
                                                        width: "150px",
                                                        textAlign: "right",
                                                        height: "35px",
                                                        color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                    }}
                                                    onChange={(e) => handleInputChange(item.id, "price", e.target.value)}
                                                />
                                                </td>
                                         
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Right Column */}
                        <div className="col-md-6">
                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='text-start'>Food Items</th>
                                    <th className='text-center'>Per Person Quantity</th>
                                    <th className='text-center'>Per Person Price</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {items.slice(Math.ceil(items.length / 2)).map(item => (
                                        <tr key={item.id}>
                                            <td className='text-black'>{item.name}</td>
                                            <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', height: '100%' }}>
                                                <input
                                                type="number"
                                                className="form-control form-control-sm no-spinner"
                                                value={itemValues[item.id]?.quantity || ""}
                                                style={{
                                                    width: "85px",
                                                    height: "35px",
                                                    padding: "0 5px",
                                                    textAlign: "right",
                                                    boxSizing: "border-box",
                                                    color: "black",
                                                    fontSize: "16px",  // increased font size
                                                    fontWeight: "bold" // make text bold
                                                }}
                                                onChange={(e) => handleInputChange(item.id, "quantity", e.target.value)}
                                                />
                                                <span className='text-black' style={{ display: 'flex', alignItems: 'center' }}>{item.unit_slug}</span>
                                            </div>
                                            </td>
                                            <td className='text-end'>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    value={itemValues[item.id]?.price || ""}
                                                    style={{
                                                        width: "150px",
                                                        textAlign: "right",
                                                        height: "35px",
                                                        color: "black",
                                                        fontSize: "16px",  // increased font size
                                                        fontWeight: "bold" // make text bold
                                                    }}
                                                    onChange={(e) => handleInputChange(item.id, "price", e.target.value)}
                                                />
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                <div className="text-end mt-3">
                    <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        ) : (
            <p className="text-center text-muted fs-6 fw-semibold">
                No items available for the selected category/subcategory.
            </p>
        )
    ) : (
        <p className="text-center text-muted fs-6 fw-semibold">
            Plan your food items quantity and price for catering & Corporate management
        </p>
    )}
</div>

        </>
    );
};

export default ManageCatCorpMenu;
